export default "__VITE_ASSET__BNeoY8N8__"